
const mineSetLangCN = {
    setLang:"设置语言",
    language:"当前语言"
}


const mineSetLangEN = {
    setLang:"设置语言",
    language:"当前语言"
}

const langPackage = {
    cn:mineSetLangCN,
    en:mineSetLangEN
}

export {langPackage}
